export default __webpack_public_path__ + "static/char-s-37-en-56429c8e2715d3ed36e8d9c2006a9dcd.png";